module.exports = __webpack_public_path__ + "img/airwallex.622f6040.svg";